// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__gHi83"};